module.exports = __webpack_public_path__ + "img/icon-plan.59ee8ba0.png";